module.exports = __webpack_public_path__ + "img/hr.45ef3354.svg";